import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';

interface IntWireInCountryListResponse {
  allowedCountriesNames: string[];
  blockedCountriesNames: string[];
}

export const useGetIntWireInAllowedCountries = ({
  customerId,
  accountExternalId,
}: {
  customerId: string;
  accountExternalId: string;
}) =>
  useQuery<IntWireInCountryListResponse>(
    'tIntWireInAllowedCountries',
    async () => {
      if (!customerId || !accountExternalId) {
        throw new Error('Invalid customerId or accountExternalId');
      }
      const { data } = await httpService.get<IntWireInCountryListResponse>(
        `${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/international/wire/in/countryList`,
      );
      return data;
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,

      cacheTime: 3600,
    },
  );
